import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, Chip, Icon, Stack, Typography } from 'investira.react.components';
import { PAISES } from '../../../enums';
import { getIndicadoresTipoRouteById } from '../_shared/indicadoresTipoRoute';

/** Apresenta um indicador retornado pela pesquisa. */
const IndicadoresItem = memo(pProps => {
  const { data: xIndicador, pathnameBase } = pProps;
  const xTipo = getIndicadoresTipoRouteById(xIndicador.indicador_tipo_id);
  const xPais = PAISES[xIndicador.pais_id];

  return (
    <Card sx={{ height: '100%' }}>
      <Link to={`${pathnameBase}/${xIndicador.indicador_id}`}>
        <Stack px={2} py={2} spacing={2} height="100%">
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1}>
            <Stack
              backgroundColor="primary.main"
              width="36px"
              height="36px"
              flexShrink={0}
              justifyContent="center"
              alignItems="center"
              borderRadius="8px">
              {xTipo && <Icon iconName={xTipo.iconName} color="secondary" size={18} />}
            </Stack>
            {xPais?.pais && (
              <Chip label={xPais.pais} size="small" color="primary" variant="outlined" />
            )}
          </Stack>
          <Stack flexGrow={1}>
            <Typography variant="body2" color="textPrimary" sx={{ fontWeight: 600 }}>
              {xIndicador.indicador_sigla || xIndicador.indicador_id}
            </Typography>
            <Typography variant="caption" color="textPrimary">
              {xIndicador.indicador}
            </Typography>
          </Stack>
        </Stack>
      </Link>
    </Card>
  );
});

IndicadoresItem.propTypes = {
  data: PropTypes.object.isRequired,
  pathnameBase: PropTypes.string
};

IndicadoresItem.defaultProps = {
  pathnameBase: '/indicadores'
};

IndicadoresItem.displayName = 'IndicadoresItem';

export default IndicadoresItem;
